import React, { FC, InputHTMLAttributes, SyntheticEvent } from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import ErrorMessage from '../error-message/error-message';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  hasLabel?: boolean;
  isChecked: boolean;
  label?: string;
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void;
  register?: UseFormRegister<FieldValues>;
  errors?: any;
  disabled?: boolean;
  isValid?: boolean;
  errorMessage?: string;
}

const checkBoxStyle = `w-[15px] h-[15px] appearance-none focus:ring-0 rounded-sm`;
const labelStyle =
  'ml-[10.5px] font-open-sans text-form-text font-normal text-thryv-black-500 capitalize';

export const Checkbox: FC<CheckboxProps> = ({
  className,
  hasLabel,
  id,
  isChecked,
  label,
  name,
  onChange,
  register,
  errors,
  disabled,
  isValid,
  errorMessage,
  ...rest
}: CheckboxProps) => {
  /* Checking for missing required props */
  // if (!id)
  //   throw new Error(
  //     `You need to pass a prop called "id" of type string to the Checkbox. To learn more about the list of required props for the
  //     Checkbox component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-checkbox-radio--checkbox`
  //   );
  // if (!name)
  //   throw new Error(
  //     `You need to pass a prop called "name" of type string to the Checkbox. To learn more about the list of required props for the
  //     Checkbox component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-checkbox-radio--checkbox`
  //   );
  // if (!value)
  //   throw new Error(
  //     `You need to pass a prop called "name" of type string to the Checkbox. To learn more about the list of required props for the
  //     Checkbox component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-checkbox-radio--checkbox`
  //   );
  /* Checking for missing required props */

  return (
    <div className="flex flex-col">
      <label
        className="inline-flex items-center"
        htmlFor={`${id || ''} ${name || ''}`}
      >
        <input
          className={`
        ${checkBoxStyle} 
        border-2 border-solid border-thryv-gray-light-500 checked:border-2 checked:border-solid min-w-[15px]
        ${
          disabled
            ? 'checked:border-thryv-gray-light-500'
            : 'checked:border-thryv-black-500'
        } ${
            disabled
              ? 'checked:bg-thryv-gray-light-500'
              : 'checked:bg-thryv-black-500'
          } 
          transition-all duration-300 ease-in-out cursor-pointer 
        ${className || ''}
        `}
          type="checkbox"
          checked={isChecked && isChecked}
          id={id || ''}
          name={name || ''}
          onChange={onChange}
          disabled={disabled}
          {...(register && {
            ...register(`${name}`, { required: `${name} is required.` }),
          })}
          {...rest}
        />
        {hasLabel && label && <span className={labelStyle}>{label}</span>}
      </label>
      {errors && name && errors[name] && errors[name].message && (
        <ErrorMessage errorMessage={errors[name].message} />
      )}
      {!isValid && errorMessage && <ErrorMessage errorMessage={errorMessage} />}
    </div>
  );
};
